import {
  DebouncedDateInput,
  useFieldLabel,
  Group,
  GroupItem,
  GroupTitle,
} from "ra-friendsofbabba";
import React from "react";
import DebouncedNumberInput from "../../component/input/DebouncedNumberInput";
import useFormPermission from "../useFormPermission";

const DetermineGroupInput = ({ ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const hasFormPermission = useFormPermission();
  return (
    <Group wrapper {...props}>
      <GroupTitle title={fieldLabel(props.source)} />
      <Group>
        <GroupItem lg={4} md={5} sm={6}>
          <DebouncedNumberInput
            source="determine_number"
            disabled={!hasFormPermission("determine_number")}
          />
        </GroupItem>

        <GroupItem lg={4} md={5} sm={6}>
          <DebouncedDateInput
            source="determine_date"
            disabled={!hasFormPermission("determine_date")}
          />
        </GroupItem>
      </Group>

      {/* <DebouncedTextInput
        {...props}
        source="provision"
        maxLength={500}
        fullWidth
        multiline
        disabled={!hasFormPermission("provision")}
        rows={3}
      /> */}
    </Group>
  );
};

export default DetermineGroupInput;
